import {call, put, takeEvery, takeLatest, cancel} from 'redux-saga/effects'
import moment from 'moment'
import {
  REPORTS_INVOICES_PAGE_REQUEST,
  REPORTS_INVOICES_LIST_INVOICE_REQUEST,
  REPORTS_INVOICES_CHANGE_DATE,
  REPORTS_INVOICES_CHANGE_OUTLET,
  REPORTS_INVOICES_RECEIPT_REQUEST,
  REPORTS_INVOICES_HIDE_RECEIPT,
  REPORTS_INVOICES_RECORD_PAYMENT_REQUEST,
  REPORTS_INVOICES_RESEND_EMAIL,
  REPORTS_INVOICES_PRINT_RECEIPT_PDF,
  REPORTS_INVOICES_ISSUE_REFUND_REQUEST,
  REPORTS_INVOICES_ISSUE_OLD_REFUND_REQUEST,
  REPORTS_INVOICES_EXPORT_INVOICES,
  REPORTS_INVOICES_CHANGE_STATUS,
  REPORTS_INVOICES_ON_CLICK_RECORD_PAYMENT,
  REPORTS_INVOICES_ON_CANCEL_RECORD_PAYMENT
} from 'actions/reports/invoices/constants'
import {
  LOGOUT
} from 'actions/constants'
import { postRefund, postOldRefund } from 'sagas/api/refunds'
import { getFilteredDate } from 'sagas/api/get-filtered-date'
import { getProfile } from 'sagas/api/profile'
import {
  getInvoices,
  getReceiptInvoices,
  resendEmail,
  createRecordPayment
} from 'sagas/api/invoices'
import {
  listInvoiceRequest,
  setListInvoice,
  setReceiptInvoices,
  hideCancelInvoiceModal,
  hideReceiptInvoice,
  invoicesPageRequest,
  hideOldCancelInvoiceModal,
  hideRecordPaymentModal,
  setOutlets,
  showRecordPaymentModal,
  setCurrentPage,
  setTotalPage
} from 'actions/reports/invoices'
import * as apiOutlets from 'api/outlets'
import {loginOutlet} from 'sagas/api/login'
import * as actActionBar from 'actions/actionBar'
import * as api from 'api/invoices'
import * as actGetExportedFile from 'actions/get-exported-file'
import * as actNotif from 'actions/notifications'
import * as act from 'actions'
import {initialize} from 'redux-form'
import {showPageLoadingSpinner} from 'actions/loadingSpinner'
import * as mpReportsInvoices from 'mixpanel/reports/invoices'

function * fillForm (outletIds, startDate, endDate) {
  yield put(initialize('search', {
    outlet: outletIds,
    date: {startDate, endDate}
  }))
  yield put(actActionBar.setSelectedOutletIds(outletIds))
}

function * closeRightColumn () {
  const toggledClass = 'col-sm-12 col-md-6 col-xs-6'
  $('#mk-col-left, #mk-col-right').removeClass(toggledClass)
  $('#mk-col-left').addClass('col-sm-12')
}

export function * invoicesPageRequestFlow () {
  try {
    yield put(setListInvoice(null))
    yield put(showPageLoadingSpinner(true))
    // remove any previous receipt invoice
    yield put(setReceiptInvoices(null))
    // hide receipt in first load page
    yield call(closeRightColumn)

    // call date api
    let filteredDate = yield call(getFilteredDate)
    let start = moment(filteredDate.start_date, 'YYYY-MM-DD')
    let end = moment(filteredDate.end_date, 'YYYY-MM-DD')

    let startDateFormatted = start.format('D/M/YYYY')
    let endDateFormatted = end.format('D/M/YYYY')

    // set outlets
    const resOutlets = yield call(apiOutlets.outlets)
    yield put(setOutlets(resOutlets.data))
    yield put(actActionBar.setOutlets(resOutlets.data))

    let profile = yield call(getProfile)

    // set form state
    yield call(fillForm, profile.outlet_id, start, end)

    yield put(listInvoiceRequest({startDate: startDateFormatted, endDate: endDateFormatted, page: 1}))
    mpReportsInvoices.reportsInvoiceStart({
      outletIds: profile.outlet_id,
      startDate: start,
      endDate: end
    })
    $('#invoice-table-tbody').animate({scrollTop: 0}, 'slow')
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
  }
}

export function * getInvoicesFlow (request) {
  let {payload: {query, previousInvoices}} = request
  let start = query.startDate
  let end = query.endDate
  let page = query.page
  let perPage = query.perPage
  let status = query.status
  let keyword = query.keyword
  let resInvoices = yield call(getInvoices, {start, end, page, perPage, status, keyword})
  if (!previousInvoices) yield put(setListInvoice(null))
  if (resInvoices) {
    let invoices
    if (previousInvoices) {
      invoices = previousInvoices.concat(resInvoices.results)
    } else {
      invoices = resInvoices.results
    }
    yield put(setListInvoice(invoices))
    yield put(setCurrentPage(page))
    yield put(setTotalPage(resInvoices.total_pages))
  }
  yield put(showPageLoadingSpinner(false))
}

export function * changeDateInvoicesFlow (request) {
  yield put(setListInvoice(null))
  yield put(showPageLoadingSpinner(true))
  yield put(setReceiptInvoices(null))
  yield call(closeRightColumn)

  let {payload} = request
  let {startDate, endDate, statuses, keyword} = payload
  let startDateFormatted = moment(startDate).format('D/M/YYYY')
  let endDateFormatted = moment(endDate).format('D/M/YYYY')

  yield put(listInvoiceRequest({
    startDate: startDateFormatted, endDate: endDateFormatted, page: 1, status: statuses, keyword: keyword
  }))
}

export function * changeOutletInvoicesFlow (request) {
  yield put(setListInvoice(null))
  yield put(showPageLoadingSpinner(true))
  yield put(setReceiptInvoices(null))
  yield call(closeRightColumn)
  // noinspection InfiniteLoopJS
  let {payload} = request
  let {outletIds, startDate, endDate, keyword} = payload
  yield call(loginOutlet, {id: outletIds})
  yield call(fillForm, outletIds, startDate, endDate)
  let startDateFormatted = startDate.format('D/M/YYYY')
  let endDateFormatted = endDate.format('D/M/YYYY')

  yield put(listInvoiceRequest({
    startDate: startDateFormatted, endDate: endDateFormatted, page: 1, status: [], keyword: keyword
  }))
}

export function * changeStatusInvoicesFlow (request) {
  yield put(setListInvoice(null))
  yield put(showPageLoadingSpinner(true))
  yield put(setReceiptInvoices(null))
  yield call(closeRightColumn)

  let {payload} = request
  let {startDate, endDate, statuses, keyword} = payload
  let startDateFormatted = startDate.format('D/M/YYYY')
  let endDateFormatted = endDate.format('D/M/YYYY')

  yield put(listInvoiceRequest({
    startDate: startDateFormatted, endDate: endDateFormatted, page: 1, status: statuses, keyword
  }))
}

export function * receiptInvoicesRequestFlow (request) {
  let {id, isMobile} = request.payload
  let receiptInvoices = yield call(getReceiptInvoices, id)
  mpReportsInvoices.reportsInvoicesSelect({
    invoice: receiptInvoices
  })

  let checkouts = receiptInvoices.checkouts
  let sorted = sortCheckouts(checkouts)
  receiptInvoices.checkouts = null
  receiptInvoices.checkouts = sorted
  for (var i = 0; i < receiptInvoices.payment_refunds.length; i++) {
    let checkoutsRefund = receiptInvoices.payment_refunds[i].checkouts
    let sorted = sortCheckouts(checkoutsRefund)
    receiptInvoices.payment_refunds[i].checkouts = null
    receiptInvoices.payment_refunds[i].checkouts = sorted
  }
  yield put(setReceiptInvoices(receiptInvoices))

    // animation
  if (!isMobile) {
    if ($('#mk-col-left').hasClass('col-sm-12')) {
      $('#mk-col-left, #mk-col-right').toggleClass('col-sm-12 col-md-6 col-xs-6')
      setTimeout(function () {
        $('#mk-col-right').show()
        $('[data-toggle="popover"]').popover()
      }, 600)
    }
  }
}

export function * hideReceiptInvoiceFlow (request) {
  let {isMobile} = request.payload
  yield put(setReceiptInvoices(null))

  if (!isMobile) {
      // animation
    $('#mk-col-right').hide()
    $('#mk-col-left, #mk-col-right').toggleClass('col-sm-12 col-md-6 col-xs-6')
  }
}

export function * createRecordPaymentFlow (request) {
  let recordPayment = request.payload.data
  yield call(createRecordPayment, recordPayment)
  yield call(resendEmail, recordPayment.id)
  yield put(actNotif.success('Record payment has been created and Invoice Email has been successfully sent'))
  yield put(hideRecordPaymentModal())
}

export function * resendEmailFlow (request) {
  let {invoiceId} = request.payload
  yield call(resendEmail, invoiceId)
  yield put(actNotif.success('Email has been successfully resend'))
}

export function * printReceiptInvoicePdfFlow (request) {
  let invoiceId = request.payload.invoiceId
  yield call(api.printReceiptInvoicePdf, invoiceId)
}

export function * issueRefundFlow (request) {
  let data = request.payload.data
  yield call(postRefund, data)
  yield put(hideCancelInvoiceModal())
  yield put(hideReceiptInvoice())
  yield put(invoicesPageRequest())
}

export function * issueOldRefundFlow (request) {
  let {data} = request.payload
  yield call(postOldRefund, data)
  yield put(hideOldCancelInvoiceModal())
  yield put(hideReceiptInvoice())
  yield put(invoicesPageRequest())
}

export function * exportInvoicesFlow (request) {
  let {query, filename, outletId} = request.payload
  try {
    yield call(api.exportInvoices, query)
    yield put(actGetExportedFile.getExportedFile(filename, outletId, 'invoices'))
  } catch (error) {
    yield put(actNotif.error(error.message))
  }
}

export function * cancelAction (cancelledTasks, request) {
  yield cancel(...cancelledTasks)
}

export function * onClickRecordPaymentFlow (request) {
  // reset form
  yield put(initialize('recordPaymentForm', {
    amount_received: null,
    payment_type: 'cash',
    note: '',
    payment_date: moment()
  }))
  yield put(showRecordPaymentModal())
}

export function * onCancelRecordPaymentFlow (request) {
  yield put(hideRecordPaymentModal())
}

function sortCheckouts (checkouts) {
  const sortedSt = {}
  const sortedNoSt = {}
  let key
  let a = []
  for (key in checkouts) {
    if (checkouts.hasOwnProperty(key)) {
      a.push(key)
    }
  }
  a.sort(insensitive)
  for (key = 0; key < a.length; key++) {
    if (a[key] !== 'No Sales Type') {
      sortedSt[a[key]] = checkouts[a[key]]
    } else {
      sortedNoSt[a[key]] = checkouts[a[key]]
    }
  }
  return Object.assign(sortedSt, sortedNoSt)
}

function insensitive (s1, s2) {
  var s1lower = s1.toLowerCase()
  var s2lower = s2.toLowerCase()
  return s1lower > s2lower ? 1 : (s1lower < s2lower ? -1 : 0)
}

export default function * reportsInvoicesSaga () {
  const pageReqTask = yield takeLatest(REPORTS_INVOICES_PAGE_REQUEST, invoicesPageRequestFlow)
  const getInvoicesTask = yield takeLatest(REPORTS_INVOICES_LIST_INVOICE_REQUEST, getInvoicesFlow)
  const changeDateInvoiceTask = yield takeLatest(REPORTS_INVOICES_CHANGE_DATE, changeDateInvoicesFlow)
  const changeOutletTask = yield takeLatest(REPORTS_INVOICES_CHANGE_OUTLET, changeOutletInvoicesFlow)
  const receiptInvoiceTask = yield takeLatest(REPORTS_INVOICES_RECEIPT_REQUEST, receiptInvoicesRequestFlow)
  yield takeLatest(REPORTS_INVOICES_HIDE_RECEIPT, hideReceiptInvoiceFlow)
  const resendEmailTask = yield takeLatest(REPORTS_INVOICES_RESEND_EMAIL, resendEmailFlow)
  const printReceiptInvoicePdfTask = yield takeLatest(REPORTS_INVOICES_PRINT_RECEIPT_PDF, printReceiptInvoicePdfFlow)
  yield takeEvery(REPORTS_INVOICES_RECORD_PAYMENT_REQUEST, createRecordPaymentFlow)
  yield takeEvery(REPORTS_INVOICES_ISSUE_REFUND_REQUEST, issueRefundFlow)
  yield takeEvery(REPORTS_INVOICES_ISSUE_OLD_REFUND_REQUEST, issueOldRefundFlow)
  const exportInvoiceTask = yield takeLatest(REPORTS_INVOICES_EXPORT_INVOICES, exportInvoicesFlow)
  yield takeEvery(REPORTS_INVOICES_CHANGE_STATUS, changeStatusInvoicesFlow)
  yield takeLatest(REPORTS_INVOICES_ON_CLICK_RECORD_PAYMENT, onClickRecordPaymentFlow)
  yield takeLatest(REPORTS_INVOICES_ON_CANCEL_RECORD_PAYMENT, onCancelRecordPaymentFlow)
  yield takeEvery(LOGOUT, cancelAction, [
    pageReqTask, getInvoicesTask, changeDateInvoiceTask, changeOutletTask, receiptInvoiceTask, resendEmailTask,
    printReceiptInvoicePdfTask, exportInvoiceTask
  ])
}



// WEBPACK FOOTER //
// ./app/sagas/reports/invoices.js